import {
  Box,
  Button,
  Divider,
  IconButton,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import FilePresentOutlinedIcon from "@mui/icons-material/FilePresentOutlined";
import { brand } from "../../../theme/themePrimitives";

export interface InformationModalProps {
  open: boolean;
  onClose: () => void;
  removedFiles: number;
  notRemovedFiles: number;
  notRemovableFiles: Array<{ name: string; user: string }>;
}

export const InformationModal: React.FC<InformationModalProps> = ({
  open,
  onClose,
  removedFiles,
  notRemovableFiles,
  notRemovedFiles,
}) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 544,
          bgcolor: "#FFFFFF",
          borderRadius: "12px",
          boxShadow: 24,
          p: 0,
          outline: "none",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            p: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography fontWeight={600} color="#101828" fontSize={18}>
              Limited Removal Permissions
            </Typography>
            <IconButton
              sx={{
                border: "none",
              }}
              onClick={handleClose}
              size="medium"
            >
              <CloseIcon sx={{ color: "#98A2B3" }} />
            </IconButton>
          </Box>
          <Stack flexDirection="row" alignItems="center" gap="3px">
            <ErrorOutlineOutlinedIcon sx={{ color: "#DC6803" }} />
            <Typography variant="body2" color="#DC6803">
              You can only remove files you uploaded
            </Typography>
          </Stack>
        </Box>
        <Divider sx={{ mb: 2 }} />

        {/* Body */}
        <Stack
          flexDirection="column"
          m={3}
          p="8px 12px"
          sx={{
            border: "1px solid  #FEF0C7",
            borderRadius: "4px",
            background: "#FFFCF5",
          }}
        >
          <Typography color="#101828">
            <Typography component="span" fontWeight={600}>
              {removedFiles} {removedFiles > 1 ? "files" : "file"}
            </Typography>{" "}
            is removed.
          </Typography>
          <Typography color="#101828">
            <Typography component="span" fontWeight={600}>
              {notRemovedFiles} {notRemovedFiles > 1 ? "files" : "file"}
            </Typography>{" "}
            cannot be removed due to insufficient permissions.
          </Typography>
        </Stack>

        {notRemovableFiles.length > 0 && (
          <Box m={3}>
            <Typography color="#101828" fontWeight={600} fontSize={14} mb={1}>
              Files you cannot remove:
            </Typography>
            <Stack gap={1.5}>
              {notRemovableFiles.map((file, index) => {
                return (
                  <Stack
                    key={`${file.name}-${index}`}
                    flexDirection="row"
                    sx={{
                      border: "1px solid  #EAECF0",
                      borderRadius: "8px",
                      background: "#F9FAFB",
                      p: "8px 12px",
                      gap: 1,
                    }}
                  >
                    <FilePresentOutlinedIcon />
                    <Stack>
                      <Typography fontWeight={600} color="#101828">
                        {file.name}
                      </Typography>
                      <Typography color="#101828">
                        Uploaded by {file.user}
                      </Typography>
                    </Stack>
                  </Stack>
                );
              })}
            </Stack>
          </Box>
        )}

        {/* Action Buttons */}
        <Stack direction="row" justifyContent="flex-end" m={3}>
          <Button
            sx={{
              px: 2,
              borderRadius: "12px",
              backgroundColor: `${brand[600]} !important`,
              color: `white`,
              "&:hover": {
                bgcolor: `${brand[700]} !important`,
                textDecoration: "underline",
              },
            }}
            onClick={onClose}
          >
            Close
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default InformationModal;
